/**
 * Starter ball-tap handlers — lab-flow redesign (third playtest
 * 2026-08-02).
 *
 * The draft modal now fires at the end of Oak's speech (and re-fires
 * from the Oak tap) — the balls are SET DRESSING, not the launcher.
 * "It doesn't make a lot of sense for you to run over and touch a
 * particular Poké Ball and be presented with all three options."
 *
 * Tap behavior:
 *   pre-pick  — the dialogue table's species line has already shown
 *               (tap flow is dialogue-then-handler), so the handler is
 *               a deliberate no-op: the ball tells you WHO it holds;
 *               Oak gives you the CHOICE.
 *   post-pick — the remaining unpicked ball answers with the cartridge
 *               "already taken" line (PR A3 eng-review decision 3 —
 *               a silent no-op reads as a bug).
 */
import type { Handler, ScriptCtx } from '../scriptRunner';
import { FLAGS } from '../flagRegistry';

const ALREADY_TAKEN = ['That POKéMON belongs to someone else.'];

const ballHandler: Handler = async (ctx: ScriptCtx) => {
  if (ctx.runState.hasFlag(FLAGS.STARTER_PICKED)) {
    ctx.worldScene.showDialogue(ALREADY_TAKEN, null);
    return;
  }
  // Pre-pick: species dialogue already displayed via the dialogue
  // table; the draft launches from Oak, not from the table.
};

export const LAB_STARTER_BALL_HANDLERS: ReadonlyArray<{
  scriptRef: string;
  handler: Handler;
}> = [
  {
    scriptRef: 'PalletTown_ProfessorOaksLab_EventScript_BulbasaurBall',
    handler: ballHandler,
  },
  {
    scriptRef: 'PalletTown_ProfessorOaksLab_EventScript_SquirtleBall',
    handler: ballHandler,
  },
  {
    scriptRef: 'PalletTown_ProfessorOaksLab_EventScript_CharmanderBall',
    handler: ballHandler,
  },
];
